import { createAsyncThunk } from '@reduxjs/toolkit'
import { newsGetList } from './news.thunk';
import { productsGetList } from './product.thunk';
import { checkAccessThunk } from './auth.thunks';
import { categoriesList } from './category.thunk';

export const appBootstrap = createAsyncThunk(
    'App/Bootstrap',
    async (_, thunkAPI) => {
        thunkAPI.dispatch(categoriesList());
        thunkAPI.dispatch(newsGetList());
        thunkAPI.dispatch(productsGetList());
        thunkAPI.dispatch(checkAccessThunk());
    }
)